import * as actionTypes from '../actionTypes';
import { moduleTypes } from '../../util/constants';
import { getAxiosInstance } from '../../util/service';

/**
 * Dispatch Dashboard Redux Actions (v2)
 *
 * Changes from original:
 *  - Removed getCompanyId() / isManagement() from frontend — server resolves from auth token
 *  - store.getState() replaced with getState via thunk's second arg (proper pattern)
 *  - forceLogout changed from GET → POST
 *  - Cleaner error handling
 */

// ─── Call List ──────────────────────────────────────────────────────────────

export const getCallList = (isForMap = false) => {
    const url = `dashboard/callList?isForMap=${isForMap}`;
    return async (dispatch) => {
        try {
            const response = await getAxiosInstance(moduleTypes.DISPATCH).get(url);
            dispatch({
                type: actionTypes.GET_DISPATCH_CALL_LIST,
                callList: response.status === 200 ? response.data.response : []
            });
        } catch (error) {
            console.error('getCallList failed:', error.message);
            dispatch({ type: actionTypes.GET_DISPATCH_CALL_LIST, callList: [] });
        }
    };
};

// ─── Truck List ─────────────────────────────────────────────────────────────

export const getTruckList = (accountId = 0) => {
    const url = `dashboard/truckList?accountId=${accountId}`;
    return async (dispatch) => {
        try {
            const response = await getAxiosInstance(moduleTypes.DISPATCH).get(url);
            dispatch({
                type: actionTypes.GET_DISPATCH_TRUCK_LIST,
                truckList: response.status === 200 ? response.data.response : []
            });
        } catch (error) {
            console.error('getTruckList failed:', error.message);
            dispatch({ type: actionTypes.GET_DISPATCH_TRUCK_LIST, truckList: [] });
        }
    };
};

// ─── Clear / Cancel ─────────────────────────────────────────────────────────

export const invoiceClearOrCancel = (req) => {
    return async () => {
        const url = `dashboard/${req.invoiceId}/clearOrCancel`;
        try {
            const payload = { callStatus: req.status, noteText: req.note || '' };
            const response = await getAxiosInstance(moduleTypes.DISPATCH).put(url, payload);
            return {
                statusCode: response.status === 200 ? 200 : null,
                statusMsg: response.data.statusMsg || response.data.message
            };
        } catch (ex) {
            return { statusCode: null, statusMsg: ex.message };
        }
    };
};

// ─── Force Logout (now POST) ────────────────────────────────────────────────

export const forceLogout = (driverId, truckId) => {
    const url = `dashboard/forceLogout/${driverId}?truckId=${truckId}`;
    return async () => {
        try {
            const response = await getAxiosInstance(moduleTypes.MANAGE).post(url);
            return {
                statusCode: response.status === 200 ? 200 : null,
                statusMsg: response.data.statusMsg
            };
        } catch (ex) {
            return { statusCode: null, statusMsg: ex.message };
        }
    };
};

// ─── Legacy thunks (backward compat for assignPage, serviceCallInfo, etc.) ──

export const getAccountByInvoice = (invoice) => {
    return async (dispatch, getState) => {
        try {
            const callList = getState().dispatchCalls.callList || [];
            const invoiceRec = callList.find((item) => item.invoiceId === invoice);
            return invoiceRec ? invoiceRec.accountId || 0 : 0;
        } catch (error) {
            return 0;
        }
    };
};

export const getInvoiceDetails = (invoice) => {
    return async (dispatch, getState) => {
        try {
            const callList = getState().dispatchCalls.callList || [];
            const invoiceRec = callList.find((item) => item.invoiceId === invoice);
            dispatch({
                type: actionTypes.GET_INVOICE_DETAILS,
                invoiceRecord: invoiceRec || {}
            });
        } catch (error) {
            dispatch({ type: actionTypes.GET_INVOICE_DETAILS, invoiceRecord: {} });
        }
    };
};

// ─── Selectors ──────────────────────────────────────────────────────────────

export const selectCallList = (state) => state.dispatchCalls.callList || [];
export const selectTruckList = (state) => state.dispatchCalls.truckList || [];

export const selectAccountIdByInvoice = (state, invoiceId) => {
    const call = (state.dispatchCalls.callList || []).find(item => item.invoiceId === invoiceId);
    return call ? call.accountId || 0 : 0;
};
